import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
const included = ['6 Tomes Premium Illustrés', '5 Bonus Cliniques Offerts', '300+ Pages de Contenu', '84 Cartes de Phrases de Guérison', 'Schémas de Constellation Illustrés', 'Modèles de Génogramme Professionnels', '10 Scripts de Méditation Complets', 'Journal d’Intégration 30 Jours', 'Accès à Vie · Téléchargement Immédiat'];
export function PricingPack() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-155" data-mp="1t1lhu4abfvve">
      <Reveal className="mx-auto max-w-3xl" data-id="element-156" data-mp="1y1zdemuqddcj">
        <div className="text-center" data-id="element-157" data-mp="1k2q9aljsu9ox">
          <h2 className="font-serif text-4xl leading-tight text-navy sm:text-5xl" data-id="element-158" data-mp="1k1oo3o92k6th">
            💳 Votre investissement <span className="text-sage" data-id="element-159" data-mp="1o30c5pcaojzk">aujourd’hui</span>
          </h2>
        </div>
        <div id="collection-complete" className="mt-10 scroll-mt-4 overflow-hidden rounded-2xl border border-amber/50 bg-surface shadow-elevated" data-id="element-160" data-mp="8mi2g7xc4c7g">
          <div className="border-b border-amber/40 bg-amber-pale px-5 py-3 text-center text-sm font-bold text-navy" data-id="element-161" data-mp="huz1zaxesqrd">
            🧘 Package complet · Tout inclus · Sans upsells cachés · Sans abonnements
          </div>
          <div className="p-7 sm:p-10" data-id="element-162" data-mp="qx8bpykusg3p">
            <div className="text-center" data-id="element-163" data-mp="qu2l2ewkt65v">
              <h3 className="font-serif text-3xl leading-tight text-navy" data-id="element-164" data-mp="mu27sxl7r10e">
                Système des Constellations Familiales™
              </h3>
              <p className="mt-1 font-serif text-xl italic text-amber" data-id="element-165" data-mp="10siggu2mz1l6">La Collection Complète</p>
            </div>

            <div className="mt-8 grid gap-8 md:grid-cols-2" data-id="element-166" data-mp="vtfj7vswdznr">
              <div data-id="element-167" data-mp="1aiuxwdf5men3">
                <p className="text-xs font-bold uppercase tracking-[0.14em] text-sage" data-id="element-168" data-mp="1ajcz7ogobj1v">Ce que vous recevez</p>
                <ul className="mt-4 space-y-2 text-sm leading-relaxed text-slate" data-id="element-169" data-mp="15n628l699hw2">
                  {included.map(item => <li key={item} className="flex gap-2" data-id="element-170" data-mp="1em181w5e0pyu">
                      <span className="text-amber" data-id="element-171" data-mp="1ejojv191djdc">✦</span>
                      {item}
                    </li>)}
                </ul>
              </div>
              <div data-id="element-172" data-mp="h87xhs7wl83c">
                <p className="text-xs font-bold uppercase tracking-[0.14em] text-sage" data-id="element-173" data-mp="h7odm5yp09mo">Ce que tout vaut</p>
                <p className="mt-4 flex items-baseline justify-between gap-3 border-b border-navy/10 pb-3 text-sm font-bold text-navy" data-id="element-174" data-mp="l6x7datqg7i8">
                  <span data-id="element-175" data-mp="uzcq4acut046">Valeur totale réelle</span>
                  <span className="line-through" data-id="element-176" data-mp="uyl6lxwj6su9">94 EUR</span>
                </p>
                <div className="mt-5 rounded-xl bg-amber-pale p-4 text-center" data-id="element-177" data-mp="zwmmk9ynuc1i">
                  <p className="text-sm font-extrabold uppercase tracking-[0.1em] text-navy" data-id="element-178" data-mp="14wr7cc6lpsxj">
                    Vous économisez 75 EUR
                  </p>
                  <p className="mt-1 text-xs font-semibold text-sage" data-id="element-179" data-mp="18w9qb2ev3txq">Les 5 bonus sont 100% gratuits</p>
                </div>
              </div>
            </div>

            <div className="mt-8 border-t border-navy/10 pt-7 text-center" data-id="element-180" data-mp="3aqqxgjaqinht">
              <p className="text-xs font-bold uppercase tracking-[0.14em] text-sage" data-id="element-181" data-mp="336pxxurehj9v">Vous payez aujourd’hui</p>
              <div className="mt-2 font-serif text-6xl leading-none text-navy sm:text-7xl" data-id="element-182" data-mp="2yeop6itfyaol">
                19<span className="ml-2 align-super text-2xl sm:text-3xl" data-id="element-183" data-mp="2thoji90i79y0">EUR</span>
              </div>
              <p className="mt-2 text-sm text-slate" data-id="element-184" data-mp="2pg30e5xdlzfd">
                Paiement unique · Sans frais cachés · Payez en toute sécurité
              </p>
              <div className="mt-6" data-id="element-185" data-mp="3m2y5j57vy68c">
                <CTAButton href="https://systeme-des-constellations-familiales.impultienda.ar/checkout" pulse size="large" data-id="element-186" data-mp="3h5zgh132wph0">
                  ⚡ ACCÈS INSTANTANÉ
                </CTAButton>
              </div>
              <p className="mt-4 text-xs leading-6 text-slate" data-id="element-187" data-mp="384hsyxncdlia">
                🔒 Paiement Sécurisé · ⚡ Téléchargement Immédiat · 🛡️ Garantie 7 Jours · 💳 Carte Bancaire · PayPal ·
                ♾️ Accès à Vie
              </p>
            </div>
          </div>
        </div>
      </Reveal>
    </section>;
}